<!--
* @Author: DY
* @Date: 2020-05-27 14:52:13
* @Description: '当年产量'
-->
<template>
    <div class="thatYearYield">
        <div class="head">
            <div class="time" @click="showPicker = true">
                <span>{{ currentYear }}</span>
                <i class="iconfont iconxiala"></i>
            </div>
            <div class="statisticalData">
                <div>
                    <h3>{{ totalOutputStatistics.deliver_volume }}</h3>
                    <p>生产方量(方)</p>
                </div>
                <div>
                    <h3>{{ totalOutputStatistics.adjusted_sign_volume }}</h3>
                    <p>发货方量(方)</p>
                </div>
            </div>
            <van-popup
                v-model="showPicker"
                position="bottom"
            >
                <van-picker
                    show-toolbar
                    :columns="yearData"
                    :default-index="currentYearIndex"
                    @cancel="showPicker = false"
                    @confirm="onConfirm"
                ></van-picker>
            </van-popup>
        </div>
        <div class="split"></div>
        <div class="tableLest">
            <div class="title">
                <span class="van_right">
                    单位：(方)
                </span>
            </div>
            <table>
                <thead>
                    <tr>
                        <th colspan="2"></th>
                        <template v-for="(item,index) in stationData">
                            <th :key="index">
                                {{ item }}
                            </th>
                        </template>
                    </tr>
                </thead>
                <template v-for="(item,index) in productionStatistics">
                    <tbody :key="index">
                        <tr>
                            <th rowspan="2">
                                {{ item.strength_grade_name }}
                            </th>
                            <th>产量</th>
                            <template v-for="(k, i) in item.StationList">
                                <td :key="'cl'+ i">
                                    {{ k.deliver_volume }}
                                </td>
                            </template>
                        </tr><tr>
                            <th>占比</th>
                            <template v-for="(k, i) in item.StationList">
                                <td :key="'zb'+ i">
                                    {{ (k.deliver_rate).toFixed(2) }}%
                                </td>
                            </template>
                        </tr>
                    </tbody>
                </template>
            </table>
        </div>
    </div>
</template>

<script>
export default {
    name: 'that-year-yield',
    components: {},
    props: {},
    data() {
        return {
            // 年数据集
            yearData: [],
            // 当前年
            currentYear: '',
            // 当前年下标
            currentYearIndex: 0,
            // 选择年弹出层状态
            showPicker: false,
            // 总产量统计数据
            totalOutputStatistics: {
                deliver_volume: 0,
                adjusted_sign_volume: 0,
            },
            // 场站数据
            stationData: [],
            // 产量统计数据
            productionStatistics: [],
        };
    },
    watch: {},
    computed: {},
    created() {
        this.currentYear = new Date().getFullYear();
        // 添加年数据
        this.addYearData();
        // 获取产量统计数据
        this.getProductionStatistics();
    },
    mounted() {},
    methods: {
        // 确认年
        onConfirm(val) {
            this.showPicker = false;
            this.currentYear = val;

            // 获取产量统计数据
            this.getProductionStatistics();
        },
        // 添加年数据
        addYearData() {
            const startingYear = 1990;
            for (let i = 0; i < 51; i++) {
                const newYear = startingYear + i;
                if (newYear === this.currentYear) {
                    this.currentYearIndex = i;
                }
                this.yearData.push(newYear + ' 年');
            }
        },
        // 时间格式处理
        formatDate() {
            const date = new Date();
            const y = date.getFullYear();
            return y;
        },
        // 获取产量统计数据
        async getProductionStatistics() {
            this.$toast.loading();
            const yearData = parseInt(this.currentYear, 0);
            const startTime = `${yearData}-01-01 00:00:00`;
            const endTime = `${yearData + 1}-01-01 00:00:00`;
            await this.$axios
                .get('/interfaceApi/sale/accounts/get_station_production_label?'
                    + `startDate=${startTime}&endDate=${endTime}`
                )
                .then(res => {
                    if (res && res.length > 0) {
                        this.stationData = this.processingData(res[0].StationList);
                        this.productionStatistics = res;
                        let new_deliver_volume = 0;
                        let new_adjusted_sign_volume = 0;
                        res.forEach(item => {
                            item.StationList.forEach(k => {
                                k.deliver_volume = k.deliver_volume.toFixed(2);
                                k.adjusted_sign_volume = k.adjusted_sign_volume.toFixed(2);
                                new_deliver_volume += Number(k.deliver_volume * 100);
                                new_adjusted_sign_volume += Number(k.adjusted_sign_volume * 100);
                            });
                        });
                        this.totalOutputStatistics.deliver_volume = new_deliver_volume / 100;
                        this.totalOutputStatistics.adjusted_sign_volume = new_adjusted_sign_volume / 100;
                    } else {
                        this.productionStatistics = [];
                    }
                })
                .catch(error => {
                    this.$toast.fail(error.ErrorCode.Message);
                }).finally(() => {
                    this.$toast.clear();
                });
        },
        // 处理数据
        processingData(data) {
            const newData = [];
            data.forEach(item => {
                newData.push(item.station_name);
            });
            return newData;
        },
    },
};
</script>

<style scoped lang="stylus">
.thatYearYield
    .head
        padding 15rpx
        .time
            height 40rpx
            border 1px solid #D7D7D7
            border-radius 4rpx
            box-shadow 2rpx 4rpx 8rpx rgba(84, 148, 243, 0.2)
            text-align center
            line-height 38rpx
            font-size 14rpx
        .statisticalData
            display flex
            height 100rpx
            display flex
            padding-top 14rpx
            >div
                flex 1
                text-align center
                margin 0 4rpx
                padding 15rpx 0
                &:nth-of-type(1)
                    background rgba(85, 136, 241, 0.06)
                    margin-left 0
                    h3
                        color #5588F1
                &:nth-of-type(2)
                    background rgba(250, 132, 54, 0.06)
                    h3
                        color #FA8436
            h3
                font-size 16rpx
                line-height 30rpx
            p
                font-size 12rpx
                line-height 20rpx
                color #979EA7
    .split
        background #F0F0F0
        height 15rpx
        padding 0
    .tableLest
        padding 15rpx
        .title
            height 16rpx
            overflow hidden
            margin-bottom 8rpx
            h4
                font-size 16rpx
                line-height 16rpx
                color #333333
            span
                font-size 12rpx
                height 16rpx
                line-height 16rpx
                color #979EA7
        table
            width 100%
            th,td
                font-weight 400
                height 40rpx
                text-align center
            thead
                th
                    background #DEE3EF
                    border 1px solid #EBF0FC
                    color #333333
            tbody
                &:nth-of-type(odd)
                    th
                        background #DEE3EF
                        border 1px solid #EBF0FC
                        color #333333
                    td
                        background rgba(85, 136, 241, 0.04)
                        color #5588F1
                &:nth-of-type(even)
                    th
                        background #F5F2ED
                        border 1px solid #EFE4D3
                        color #823802
                    td
                        background rgba(250, 132, 54, 0.04)
                        color #FA8436
</style>
